module.exports = __webpack_public_path__ + "static/media/chickennuggets.11ef5ec2.png";